import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { memo, useState, useCallback, useMemo } from 'react';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import { Check, ExpandMore } from '@mui/icons-material';
import {
  CancellationAireFormVM,
  CancellationAireVM,
} from 'cancellations/view-models/cancellation-aire';
import CancellationAireFormMemo from './citizenship-loss-form';
import Close from '@mui/icons-material/Close';

interface CancellationAireAccordionProps {
  isLossCitizenship: boolean;
}

const CancellationAireAccordionComponent = ({
  isLossCitizenship = false,
}: CancellationAireAccordionProps): React.ReactElement => {
  const formContext = useFormikContext<CancellationAireFormVM>();
  const { cancellationAire } = formContext.values;

  const errorCancellationAire = useMemo(() => {
    return !!formContext.errors.cancellationAire;
  }, [formContext.errors.cancellationAire]);

  const onChange = useCallback(
    (key, value) => {
      formContext.setFieldValue('cancellationAire', {
        ...formContext.values.cancellationAire,
        [key]: value,
      });
    },
    [formContext.setFieldValue, formContext.values.cancellationAire]
  );

  const [open, setOpen] = useState(true);

  const title = isLossCitizenship
    ? 'Dati di perdita cittadinanza Italiana'
    : 'Dati irreperibilità presunta';

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-subject-attributes-content"
        id="panel-subject-attributes-content"
        expandIcon={<ExpandMore />}
      >
        {errorCancellationAire ? <Close color="error" /> : <Check color="success" />}
        <Typography>{title}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <CancellationAireFormMemo
          values={cancellationAire}
          onChange={onChange}
          isLossCitizenship={isLossCitizenship}
          errors={formContext.errors.cancellationAire as FormikErrors<CancellationAireVM>}
          touched={formContext.touched.cancellationAire as FormikTouched<CancellationAireVM>}
        />
      </AccordionDetails>
    </Accordion>
  );
};

CancellationAireAccordionComponent.displayName = 'Cancellation aire accordion component';

const CancellationAireAccordion = memo(CancellationAireAccordionComponent);

export default CancellationAireAccordion;
